import { Link } from "@/components/common/Link";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="201875" id="footer" className="dark bg-background text-foreground border-t border-white/20 py-16 px-6">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8 text-sm font-default text-foreground/60">
          
          {}
          <div className="flex flex-col gap-3">
            <Link to="#" className="w-fit text-foreground font-bold text-lg hover:text-accent transition-colors duration-300">
              Digital Caribe
            </Link>
            <Link to="#" className="w-fit hover:text-accent transition-colors duration-300">
              Professionelle Webseiten für Schweizer KMU
            </Link>
          </div>

          {}
          <div className="flex flex-col gap-3">
            <Link to="mailto:info@digitalcaribe.tech" className="w-fit hover:text-accent transition-colors duration-300">
              info@digitalcaribe.tech
            </Link>
            <Link to="https://calendly.com/oscar-martinez-fontenla/30min" className="w-fit hover:text-accent transition-colors duration-300">
              Beratung buchen
            </Link>
            <span className="cursor-default">
              Schweiz
            </span>
          </div>

          {}
          <div className="flex flex-col gap-3 md:items-end">
            <span className="cursor-default">
              &copy; {currentYear} Digital Caribe.
            </span>
            <span className="cursor-default">
              Alle Rechte vorbehalten.
            </span>
          </div>

        </div>
      </div>
    </section>;
}